import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

export enum IconType {
  cardView = 'cardView',
  listView = 'listView',
  user = 'user',
  cart = 'cart',
  listMenu = 'listMenu',
  search = 'search',
  close = 'close',
  back = 'back',
  rightArrow = 'rightArrow',
  upload = 'upload',
  success = 'success',
  error = 'error',
  document = 'document',
  refresh = 'refresh',
  paid = 'paid',
  time = 'time',
  inwork = 'inwork',
  checked = 'checked',
  newAddress = 'newAddress',
  trash = 'trash',
  minus = 'minus',
  plus = 'plus',
  favourites = 'favourites',
  audio = 'audio',
  kitchen = 'kitchen',
  home = 'home',
  downArrow = 'downArrow',
  upArrow = 'upArrow',
  sale = 'sale',
  arrowBack = 'arrowBack',
  arrowNext = 'arrowNext',
  compare = 'compare',
  topArrow = 'topArrow',
  bottomArrow = 'bottomArrow',
  description = 'description',
  specification = 'specification',
  reviews = 'reviews',
  related = 'related',
  photogalleryNext = 'photogalleryNext',
  photogalleryBack = 'photogalleryBack',
  fullscreen = 'fullscreen',
  dog = 'dog',
  google = 'google',
  info = 'info',
  onStock = 'onStock',
  price = 'price',
  priceDown = 'priceDown',
  edit = 'edit',
  creditCard = 'creditCard',
  percentage = 'percentage',
  finishedOrder = 'finishedOrder',
  emptyCart = 'emptyCart',
  x = 'x',
  xInCircle = 'xInCircle',
  facebook = 'facebook',
  youtube = 'youtube',
  instagram = 'instagram',
  filter = 'filter',
  category = 'category',
  location = 'location',
  arrowDown = 'arrowDown',
  locationMarker = 'locationMarker',
  download = 'download',
  cross = 'cross',
  closeThin = 'closeThin',
  backThin = 'backThin',
  rightArrowNoFill = 'rightArrowNoFill',
  recycled = 'recycled',
  delivery = 'delivery',
  new = 'new',
  saleout = 'saleout',
  gift = 'gift',
  logout = 'logout',
  eye = 'eye',
  eyeSlash = 'eyeSlash',
  tiktok='tiktok',
  deal='deal'
}

interface Props {
  icon: IconType;
  className?: string;
  viewBox?: string;
  fill?: string;
  title?: string;
  alt?: string;
  cursor?: string;
  marginLeft?: number;
  marginRight?: number;
  height?: number;
  width?: number;
  onClick?: any;
  onMouseOver?: any;
  onMouseLeave?: any;
  padding?: string;
}

const icons = {
  download: () => (
    <path
      d="M14.8,10v2.7c0,1.1-0.9,2.1-2.1,2.1H3.3c-1.1,0-2.1-0.9-2.1-2.1V10c0-0.4,0.3-0.8,0.8-0.8S2.8,9.6,2.8,10v2.7
	c0,0.3,0.3,0.6,0.6,0.6h9.3c0.3,0,0.6-0.3,0.6-0.6V10c0-0.4,0.3-0.8,0.8-0.8S14.8,9.6,14.8,10z M7.5,10.5c0.1,0.1,0.2,0.1,0.2,0.2
	c0.1,0,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2l3.3-3.3c0.3-0.3,0.3-0.8,0-1.1s-0.8-0.3-1.1,0L8.8,8.2V2
	c0-0.4-0.3-0.8-0.8-0.8S7.3,1.6,7.3,2v6.2L5.2,6.1c-0.3-0.3-0.8-0.3-1.1,0s-0.3,0.8,0,1.1L7.5,10.5z"
    />
  ),
  arrowDown: () => (
    <path
      d="M6,8.1c-0.2,0-0.3-0.1-0.4-0.2l-3-3c-0.2-0.2-0.2-0.6,0-0.9s0.6-0.2,0.9,0L6,6.6l2.6-2.6c0.2-0.2,0.6-0.2,0.9,0
	c0.2,0.2,0.2,0.6,0,0.9l-3,3C6.3,8.1,6.2,8.1,6,8.1z"
    />
  ),
  locationMarker: () => (
    <path
      id="location"
      transform="translate(-412 -1360.917)"
      d="M420,1377.1c-0.1,0-0.3,0-0.4-0.1c-0.3-0.2-6.3-4.3-6.3-9.3
	c0-3.7,3-6.8,6.8-6.8c3.7,0,6.8,3,6.8,6.8c0,5-6.1,9.1-6.3,9.3C420.3,1377,420.1,1377.1,420,1377.1z M420,1362.4
	c-2.9,0-5.2,2.4-5.2,5.2c0,3.5,3.9,6.8,5.2,7.7c1.3-1,5.2-4.2,5.2-7.7C425.2,1364.8,422.9,1362.4,420,1362.4z M420,1370.4
	c-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8s2.8,1.2,2.8,2.8S421.5,1370.4,420,1370.4z M420,1366.4c-0.7,0-1.2,0.6-1.2,1.2
	s0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2S420.7,1366.4,420,1366.4z"
    />
  ),
  location: () => (
    <>
      <path id="Path_571" data-name="Path 571" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_572"
        data-name="Path 572"
        d="M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm8.94,3A8.994,8.994,0,0,0,13,3.06V1H11V3.06A8.994,8.994,0,0,0,3.06,11H1v2H3.06A8.994,8.994,0,0,0,11,20.94V23h2V20.94A8.994,8.994,0,0,0,20.94,13H23V11H20.94ZM12,19a7,7,0,1,1,7-7A6.995,6.995,0,0,1,12,19Z"
        fill="#414141"
      />
    </>
  ),
  facebook: () => (
    <path
      id="facebook"
      d="M90.494,8587.99v-8.21h2.954l.442-3.2h-3.4v-2.04c0-.93.276-1.56,1.7-1.56h1.82v-2.86a25.223,25.223,0,0,0-2.647-.13c-2.619,0-4.412,1.49-4.412,4.23v2.36H83.99v3.2h2.961v8.21h3.542Z"
      transform="translate(-64.99 -8554.99)"
      fill="#fff"
    />
  ),
  category: () => (
    <path
      d="M20,22H4c-1.7,0-3-1.3-3-3V5c0-1.7,1.3-3,3-3h5c0.3,0,0.6,0.2,0.8,0.4L11.5,5H20c1.7,0,3,1.3,3,3v11C23,20.7,21.7,22,20,22z
	 M4,4C3.4,4,3,4.4,3,5v14c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8c0-0.6-0.4-1-1-1h-9c-0.3,0-0.6-0.2-0.8-0.4L8.5,4H4z"
    />
  ),
  filter: () => (
    <path
      d="M14,22c-0.2,0-0.3,0-0.4-0.1l-4-2C9.2,19.7,9,19.4,9,19v-6.2L1.2,3.6C1,3.3,0.9,2.9,1.1,2.6C1.3,2.2,1.6,2,2,2h20
	c0.4,0,0.7,0.2,0.9,0.6s0.1,0.8-0.1,1.1L15,12.8V21c0,0.3-0.2,0.7-0.5,0.9C14.4,22,14.2,22,14,22z M11,18.4l2,1v-6.9
	c0-0.2,0.1-0.5,0.2-0.6L19.8,4H4.2l6.6,7.8c0.2,0.2,0.2,0.4,0.2,0.6V18.4z"
    />
  ),
  youtube: () => (
    <path
      id="youtube"
      d="M23.5,6.2a3.007,3.007,0,0,0-2.088-2.088c-1.87-.5-9.4-.5-9.4-.5s-7.507-.01-9.4.5A3.007,3.007,0,0,0,.527,6.2,31.248,31.248,0,0,0,.005,12.01a31.247,31.247,0,0,0,.522,5.783,3.007,3.007,0,0,0,2.088,2.088c1.868.5,9.4.5,9.4.5s7.506,0,9.4-.5A3.007,3.007,0,0,0,23.5,17.793a31.247,31.247,0,0,0,.5-5.783,31.247,31.247,0,0,0-.5-5.8ZM9.609,15.6V8.408l6.264,3.6Z"
      transform="translate(11.995 12.384)"
      fill="#fff"
    />
  ),
  instagram: () => (
    <path
      id="instagram"
      d="M12,0C8.74,0,8.333.015,7.053.072A8.849,8.849,0,0,0,4.14.63,5.876,5.876,0,0,0,2.014,2.014,5.855,5.855,0,0,0,.63,4.14,8.823,8.823,0,0,0,.072,7.053C.012,8.333,0,8.74,0,12s.015,3.667.072,4.947A8.854,8.854,0,0,0,.63,19.86a5.885,5.885,0,0,0,1.384,2.126A5.868,5.868,0,0,0,4.14,23.37a8.86,8.86,0,0,0,2.913.558C8.333,23.988,8.74,24,12,24s3.667-.015,4.947-.072a8.88,8.88,0,0,0,2.913-.558,6.133,6.133,0,0,0,3.51-3.51,8.854,8.854,0,0,0,.558-2.913C23.988,15.667,24,15.26,24,12s-.015-3.667-.072-4.947A8.874,8.874,0,0,0,23.37,4.14a5.89,5.89,0,0,0-1.384-2.126A5.847,5.847,0,0,0,19.86.63,8.828,8.828,0,0,0,16.947.072C15.667.012,15.26,0,12,0Zm0,2.16c3.2,0,3.585.016,4.85.071a6.611,6.611,0,0,1,2.227.415,3.949,3.949,0,0,1,2.278,2.277,6.625,6.625,0,0,1,.413,2.227c.057,1.266.07,1.646.07,4.85s-.015,3.585-.074,4.85a6.753,6.753,0,0,1-.421,2.227,3.81,3.81,0,0,1-.9,1.382,3.744,3.744,0,0,1-1.38.9,6.674,6.674,0,0,1-2.235.413c-1.274.057-1.649.07-4.859.07s-3.586-.015-4.859-.074a6.8,6.8,0,0,1-2.236-.421,3.716,3.716,0,0,1-1.379-.9,3.644,3.644,0,0,1-.9-1.38,6.81,6.81,0,0,1-.42-2.235c-.045-1.26-.061-1.649-.061-4.844s.016-3.586.061-4.861A6.8,6.8,0,0,1,2.6,4.89a3.557,3.557,0,0,1,.9-1.381,3.549,3.549,0,0,1,1.379-.9A6.642,6.642,0,0,1,7.1,2.19c1.275-.045,1.65-.06,4.859-.06L12,2.16Zm0,3.678A6.162,6.162,0,1,0,18.162,12,6.162,6.162,0,0,0,12,5.838ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16ZM19.846,5.6a1.44,1.44,0,1,1-1.44-1.439A1.441,1.441,0,0,1,19.846,5.6Z"
      transform="translate(12 12)"
      fill="#fff"
    />
  ),

  x: () => (
    <path
      d="M9.7,8.3c0.4,0.4,0.4,1,0,1.4C9.5,9.9,9.3,10,9,10S8.5,9.9,8.3,9.7L6,7.4L3.7,9.7C3.5,9.9,3.3,10,3,10S2.5,9.9,2.3,9.7
	c-0.4-0.4-0.4-1,0-1.4L4.6,6L2.3,3.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L6,4.6l2.3-2.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L7.4,6
	L9.7,8.3z"
    />
  ),
  xInCircle: () => (
    <path stroke="red" stroke-width="2" d="M24 4
        A20 20 0 1 1 24 44
        A20 20 0 1 1 24 4
        M16 16 L32 32
        M16 32 L32 16" />
  ),
  cardView: () => (
    <path
      d="M8,0H2C0.9,0,0,0.9,0,2v6c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V2C10,0.9,9.1,0,8,0z M8,8H2l0-6h0h6V8z M8,12H2
	c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2v-6C10,12.9,9.1,12,8,12z M8,20H2l0-6h0h6V20z M20,0h-6c-1.1,0-2,0.9-2,2v6
	c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V2C22,0.9,21.1,0,20,0z M20,8h-6l0-6h0h6V8z M20,12h-6c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h6
	c1.1,0,2-0.9,2-2v-6C22,12.9,21.1,12,20,12z M20,20h-6l0-6h0h6V20z"
    />
  ),
  listView: () => (
    <path
      id="Icon"
      transform="translate(620.5 361.5)"
      d="M-600-354.5h-17c-0.6,0-1-0.4-1-1s0.4-1,1-1h17c0.6,0,1,0.4,1,1
    S-599.4-354.5-600-354.5z M-599-349.5c0-0.6-0.4-1-1-1h-17c-0.6,0-1,0.4-1,1s0.4,1,1,1h17C-599.4-348.5-599-348.9-599-349.5z
     M-599-343.5c0-0.6-0.4-1-1-1h-17c-0.6,0-1,0.4-1,1s0.4,1,1,1h17C-599.4-342.5-599-342.9-599-343.5z"
    />
  ),
  user: () => (
    <path
      d="M20,22c-0.6,0-1-0.4-1-1v-2c0-1.7-1.3-3-3-3H8c-1.7,0-3,1.3-3,3v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2c0-2.8,2.2-5,5-5h8
	c2.8,0,5,2.2,5,5v2C21,21.6,20.6,22,20,22z M17,7c0-2.8-2.2-5-5-5S7,4.2,7,7s2.2,5,5,5S17,9.8,17,7z M15,7c0,1.7-1.3,3-3,3
	S9,8.7,9,7s1.3-3,3-3S15,5.3,15,7z"
    />
  ),
  cart: () => (
    <path
      d="M9,23.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S10.1,23.5,9,23.5z M22,21.5c0-1.1-0.9-2-2-2s-2,0.9-2,2s0.9,2,2,2
	S22,22.6,22,21.5z M9.7,17.5h9.7c1.5,0,2.7-1,3-2.4L24,6.7c0.1-0.3,0-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.8-0.4H6.8L6,1.3
	C5.9,0.8,5.5,0.5,5,0.5H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h3.2L5,6.7c0,0,0,0.1,0,0.1l1.7,8.3C7,16.5,8.2,17.5,9.7,17.5
	C9.6,17.5,9.7,17.5,9.7,17.5z M21.8,7.5l-1.4,7.2c-0.1,0.5-0.5,0.8-1,0.8H9.7c-0.5,0-0.9-0.3-1-0.8L7.2,7.5H21.8z"
    />
  ),
  listMenu: () => (
    <path
      id="Icon"
      transform="translate(620.5 361.5)"
      d="M-600-354.5h-17c-0.6,0-1-0.4-1-1s0.4-1,1-1h17c0.6,0,1,0.4,1,1
    S-599.4-354.5-600-354.5z M-599-349.5c0-0.6-0.4-1-1-1h-17c-0.6,0-1,0.4-1,1s0.4,1,1,1h17C-599.4-348.5-599-348.9-599-349.5z
     M-599-343.5c0-0.6-0.4-1-1-1h-17c-0.6,0-1,0.4-1,1s0.4,1,1,1h17C-599.4-342.5-599-342.9-599-343.5z"
    />
  ),
  search: () => (
    <path
      d="M21.7,20.3L18,16.6c1.2-1.5,2-3.5,2-5.6c0-5-4-9-9-9c-5,0-9,4-9,9c0,5,4,9,9,9c2.1,0,4.1-0.7,5.6-2l3.7,3.7
	c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3C22.1,21.3,22.1,20.7,21.7,20.3z M4,11c0-3.9,3.1-7,7-7c3.9,0,7,3.1,7,7
	c0,1.9-0.8,3.7-2,4.9c0,0,0,0,0,0s0,0,0,0c-1.3,1.3-3,2-4.9,2C7.1,18,4,14.9,4,11z"
    />
  ),
  close: () => (
    <>
      <defs>
        <style>{`.a{fill:none;}`}</style>
      </defs>
      <g transform="translate(-15 -22)">
        <g transform="translate(-251 -4515)">
          <rect
            className="a"
            width="28"
            height="28"
            transform="translate(266 4537)"
          />
        </g>
        <path
          d="M-2056.736,595.678l-7.071-7.071-7.072,7.071a1,1,0,0,1-1.413,0,1,1,0,0,1,0-1.415l7.071-7.071-7.071-7.071a1,1,0,0,1,0-1.415,1,1,0,0,1,1.413,0l7.072,7.071,7.071-7.071a1,1,0,0,1,1.415,0,1,1,0,0,1,0,1.415l-7.072,7.071,7.072,7.072a1,1,0,0,1,0,1.413,1,1,0,0,1-.708.293A.994.994,0,0,1-2056.736,595.678Z"
          transform="translate(2092.807 -551.192)"
        />
      </g>
    </>
  ),
  back: () => <path id="arrow" d="M5.5,12,0,6,5.5,0,7,1.4,2.7,6,7,10.6Z" />,
  rightArrow: () => (
    <path
      d="M8,11c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L8,8.6l3.3-3.3c0.4-0.4,1-0.4,1.4,0
	s0.4,1,0,1.4l-4,4C8.5,10.9,8.3,11,8,11z"
      transform="rotate(270) translate(-21 0)"
      fill={'#414141'}
    />
  ),
  rightArrowNoFill: () => (
    <path
      d="M8,11c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L8,8.6l3.3-3.3c0.4-0.4,1-0.4,1.4,0
	s0.4,1,0,1.4l-4,4C8.5,10.9,8.3,11,8,11z"
      transform="rotate(270) translate(-21 0)"
    />
  ),
  upload: () => (
    <path
      d="M22,16.8v5c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v4h16v-4c0-0.6,0.4-1,1-1S22,16.2,22,16.8z
	 M5.3,10c0.3,0,0.5-0.1,0.7-0.3l5-4.9l0,11.6c0,0.6,0.4,1,1,1c0,0,0,0,0,0c0.6,0,1-0.5,1-1l0-11.6l5.1,4.9c0.4,0.4,1,0.4,1.4,0
	c0.4-0.4,0.4-1,0-1.4l-6.8-6.5c-0.1-0.1-0.2-0.1-0.3-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0
	c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0L4.6,8.3c-0.4,0.4-0.4,1,0,1.4C4.7,9.9,5,10,5.3,10z"
    />
  ),
  success: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2
	V9z"
    />
  ),
  error: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2
	V9z"
    />
  ),
  document: () => (
    <path d="M14,2H6C4.9,2,4,2.9,4,4l0,16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z M6,20V4h7v5h5v11H6z" />
  ),
  refresh: () => (
    <path
      d="M17.6,6.3c-3.1-3.1-8.2-3.1-11.3,0s-3.1,8.2,0,11.3s8.2,3.1,11.3,0c1-1,1.7-2.3,2.1-3.7h-2.1c-1.1,3.1-4.5,4.8-7.7,3.7
	S5.2,13.1,6.3,10C7.2,7.6,9.5,6,12,6c1.6,0,3.1,0.6,4.2,1.8L13,11h7V4L17.6,6.3z"
    />
  ),
  paid: () => (
    <path
      d="M12,22.5C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5c5.8,0,10.5,4.7,10.5,10.5C22.5,17.8,17.8,22.5,12,22.5z M12,3.5
	c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C20.5,7.3,16.7,3.5,12,3.5z M11.5,15.2l5.3-5
	c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-4.6,4.3l-2-2.1c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l2.7,2.8
	c0.2,0.2,0.5,0.3,0.7,0.3C11,15.5,11.3,15.4,11.5,15.2z"
    />
  ),
  time: () => (
    <path
      d="M12,22.5C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5c5.8,0,10.5,4.7,10.5,10.5C22.5,17.8,17.8,22.5,12,22.5z M12,3.5
	c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C20.5,7.3,16.7,3.5,12,3.5z M16.5,14.5c0.2-0.5,0-1.1-0.4-1.3
	l-3.2-1.6v-5c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0.4,0.2,0.7,0.6,0.9l3.7,1.9c0.1,0.1,0.3,0.1,0.4,0.1C16,15,16.3,14.8,16.5,14.5z"
    />
  ),
  inwork: () => (
    <path
      d="M17,4h-1c0-1.1-0.9-2-2-2h-4C8.9,2,8,2.9,8,4H7C5.3,4,4,5.3,4,7v12c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3V7
	C20,5.3,18.7,4,17,4z M10,4h4v2h-4V4L10,4z M18,19c0,0.6-0.4,1-1,1H7c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1h1c0,1.1,0.9,2,2,2h4
	c1.1,0,2-0.9,2-2h1c0.6,0,1,0.4,1,1V19z"
    />
  ),
  checked: () => (
    <path
      d="M4.1,7.9a.908.908,0,0,1-.7-.3L.3,4.4A.967.967,0,0,1,.3,3,.967.967,0,0,1,1.7,3L4.1,5.4,9.3.2a.967.967,0,0,1,1.4,0,.967.967,0,0,1,0,1.4l-5.9,6A.779.779,0,0,1,4.1,7.9Z"
      transform="translate(0 0.1)"
    />
  ),
  newAddress: () => (
    <path
      d="M21.5,24h-6.2c-0.6,0-1-0.4-1-1v-5.8H9.7V23c0,0.6-0.4,1-1,1H2.5C1.7,24,1,23.4,1,22.6v-13C1,9.3,1.1,9,1.3,8.8l10-8.6
	l1.3,1.5L3,10.1V22h4.7v-5.8c0-0.6,0.4-1,1-1h6.7c0.6,0,1,0.4,1,1V22H21V9.8h2v12.8C23,23.4,22.3,24,21.5,24z M20,8V5h3V3h-3V0h-2v3
	h-3v2h3v3H20z"
    />
  ),
  trash: () => (
    <path
      className="st0"
      d="M21,5h-4V4c0-1.7-1.3-3-3-3h-4C8.3,1,7,2.3,7,4v1H3C2.4,5,2,5.4,2,6s0.4,1,1,1h1v13c0,1.7,1.3,3,3,3h10
	c1.7,0,3-1.3,3-3V7h1c0.6,0,1-0.4,1-1S21.6,5,21,5z M9,4c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1v1H9V4z M18,20c0,0.6-0.4,1-1,1H7
	c-0.6,0-1-0.4-1-1V7h12V20z M11,11v6c0,0.6-0.4,1-1,1s-1-0.4-1-1v-6c0-0.6,0.4-1,1-1S11,10.4,11,11z M15,11v6c0,0.6-0.4,1-1,1
	s-1-0.4-1-1v-6c0-0.6,0.4-1,1-1S15,10.4,15,11z"
    />
  ),
  favourites: () => (
    <path
      d="M12,22.1c-0.3,0-0.5-0.1-0.7-0.3L2.5,13c-1.2-1.2-1.9-2.9-1.9-4.6c0-1.7,0.7-3.4,1.9-4.6c2.5-2.5,6.7-2.5,9.2,0L12,4.2
	l0.4-0.4c1.2-1.2,2.9-1.9,4.6-1.9c0,0,0,0,0,0c1.7,0,3.4,0.7,4.6,1.9l0,0c2.5,2.5,2.5,6.7,0,9.2l-8.8,8.8C12.5,22,12.3,22.1,12,22.1
	z M7.1,3.9c-1.2,0-2.3,0.4-3.2,1.3C3,6.1,2.5,7.2,2.5,8.4c0,1.2,0.5,2.3,1.3,3.2l8.1,8.1l8.1-8.1c0.9-0.9,1.3-2,1.3-3.2
	c0-1.2-0.5-2.3-1.3-3.2l0,0c-0.8-0.9-2-1.3-3.2-1.3c0,0,0,0,0,0c-1.2,0-2.3,0.5-3.2,1.3l-1.1,1.1c-0.4,0.4-1,0.4-1.4,0l-1.1-1.1
	C9.4,4.3,8.2,3.9,7.1,3.9z"
    />
  ),
  audio: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12v2v4v1c0,1.7,1.3,3,3,3h1c1.7,0,3-1.3,3-3v-3c0-1.7-1.3-3-3-3H4v-1c0-4.4,3.6-8,8-8s8,3.6,8,8v1h-2
	c-1.7,0-3,1.3-3,3v3c0,1.7,1.3,3,3,3h1c1.7,0,3-1.3,3-3v-1v-4v-2C22,6.5,17.5,2,12,2z M6,15c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1H5
	c-0.6,0-1-0.4-1-1v-1v-3H6z M20,19c0,0.6-0.4,1-1,1h-1c-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1h2v3V19z"
    />
  ),
  kitchen: () => (
    <path
      d="M17,23H3c-1.1,0-2-0.9-2-2l0-3c0.1-4.1,0.6-8.2,1.4-12.2l0.1-0.6C1.9,4.3,1.4,3.3,1.1,2.3L0.7,1H18c2.1,0,3.5,0.9,4,2.6
	c0.7,3.5,1.1,7.1,1,10.7l0,0.1c-0.2,1.4-1,2.6-2.2,3.4L19,18.9V21C19,22.1,18.1,23,17,23z M3,18v3h14v-3c-0.1-6.7-1.3-13.4-2-15H3.5
	c0.2,0.4,0.4,0.8,0.7,1.1l0.4,0.5L4.3,6.1C3.6,10,3.1,14,3,18z M17.1,3c1,3,1.8,9,1.9,13.6l0.8-0.5c0.7-0.4,1.1-1.1,1.2-1.9
	c0-3.4-0.3-6.8-1-10.1C19.9,3.5,19.6,3,18,3H17.1z M11,15.7v-8c0-0.6-0.4-1-1-1s-1,0.4-1,1v8c0,0.6,0.4,1,1,1S11,16.3,11,15.7z"
    />
  ),
  home: () => (
    <path
      d="M21,23H3c-0.6,0-1-0.4-1-1V9c0-0.3,0.1-0.6,0.4-0.8l9-7c0.4-0.3,0.9-0.3,1.2,0l9,7C21.9,8.4,22,8.7,22,9v13
	C22,22.6,21.6,23,21,23z M4,21h16V9.5l-8-6.2L4,9.5V21z"
    />
  ),
  downArrow: () => (
    <path
      id="Polygon_39"
      data-name="Polygon 39"
      d="M4,0,8,4H0Z"
      transform="translate(8 4) rotate(180)"
    />
  ),
  upArrow: () => (
    <path
      id="Polygon_39"
      data-name="Polygon 39"
      d="M4,0,8,4H0Z"
      transform="translate(8 4)"
    />
  ),
  sale: () => (
    <path
      d="M7.4,8.3c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9S8.8,9.3,8.3,9.3S7.4,8.8,7.4,8.3z M15.7,14.8c-0.5,0-0.9,0.4-0.9,0.9
	s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9S16.2,14.8,15.7,14.8z M24,12c0,6.6-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0S24,5.4,24,12z M5.9,8.3
	c0,1.3,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4S9.7,5.9,8.3,5.9S5.9,7,5.9,8.3z M17.2,7.9c0.3-0.3,0.3-0.8,0-1.1s-0.8-0.3-1.1,0l-9.3,9.3
	c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2L17.2,7.9z M18.1,15.7c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4
	s1.1,2.4,2.4,2.4S18.1,17,18.1,15.7z"
    />
  ),
  arrowBack: () => (
    <path
      className="st0"
      d="M15,19c-0.3,0-0.5-0.1-0.7-0.3l-6-6c-0.4-0.4-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L10.4,12l5.3,5.3
	c0.4,0.4,0.4,1,0,1.4C15.5,18.9,15.3,19,15,19z"
    />
  ),
  arrowNext: () => (
    <path
      transform="rotate(180 12,12) "
      id="svg_1"
      fill="#ffffff"
      d="m15,19c-0.3,0 -0.5,-0.1 -0.7,-0.3l-6,-6c-0.4,-0.4 -0.4,-1 0,-1.4l6,-6c0.4,-0.4 1,-0.4 1.4,0s0.4,1 0,1.4l-5.3,5.3l5.3,5.3c0.4,0.4 0.4,1 0,1.4c-0.2,0.2 -0.4,0.3 -0.7,0.3z"
      className="st0"
    />
  ),
  compare: () => (
    <path
      id="Path_88"
      d="M19.3,3.6C19.3,3.6,19.3,3.6,19.3,3.6C19.3,3.5,19.3,3.5,19.3,3.6c-0.1-0.2-0.2-0.2-0.2-0.3
	c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1L18.7,3c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0h0L13,3.5V2h-2v1.6L5.5,4.1c0,0,0,0-0.1,0
	c-0.1,0-0.2,0-0.3,0.1c0,0-0.1,0-0.1,0C5,4.3,4.9,4.3,4.8,4.4c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.2C4.2,5.7,0,14.7,0,17.3
	c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6c0-2.2-2.8-8.5-4.1-11.4L11,5.6V7h2V5.5l3.8-0.3c-1.3,2.9-3.9,9-3.9,11.1
	c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6C24,13.6,19.8,4.6,19.3,3.6z M5.6,7.5c1.2,2.7,2.3,5.4,3.2,8.2H2.3
	C3.2,12.9,4.3,10.2,5.6,7.5z M5.6,20.8c-1.8,0-3.3-1.3-3.5-3.1h7C8.9,19.5,7.4,20.9,5.6,20.8z M21.7,14.6h-6.5
	c0.9-2.8,2-5.5,3.2-8.2C19.7,9.1,20.8,11.8,21.7,14.6z M18.4,19.8c-1.8,0-3.3-1.3-3.5-3.1h7C21.8,18.4,20.2,19.8,18.4,19.8z"
    />
  ),
  description: () => (
    <path
      className="st0"
      d="M17,11H3c-0.6,0-1-0.4-1-1s0.4-1,1-1h14c0.6,0,1,0.4,1,1S17.6,11,17,11z M22,6c0-0.6-0.4-1-1-1H3
	C2.4,5,2,5.4,2,6s0.4,1,1,1h18C21.6,7,22,6.6,22,6z M22,14c0-0.6-0.4-1-1-1H3c-0.6,0-1,0.4-1,1s0.4,1,1,1h18C21.6,15,22,14.6,22,14z
	 M18,18c0-0.6-0.4-1-1-1H3c-0.6,0-1,0.4-1,1s0.4,1,1,1h14C17.6,19,18,18.6,18,18z"
    />
  ),
  specification: () => (
    <path
      className="st0"
      d="M15,8H9C8.4,8,8,8.4,8,9v6c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1V9C16,8.4,15.6,8,15,8z M14,14h-4v-4h4V14z M23,13
	h-2v-3h2c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2V6c0-1.7-1.3-3-3-3h-2V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v2h-4V1c0-0.6-0.4-1-1-1S8,0.4,8,1v2H6
	C4.3,3,3,4.3,3,6v2H1C0.4,8,0,8.4,0,9s0.4,1,1,1h2v3H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h2v3c0,1.7,1.3,3,3,3h2v2c0,0.6,0.4,1,1,1
	s1-0.4,1-1v-2h4v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2h2c1.7,0,3-1.3,3-3v-3h2c0.6,0,1-0.4,1-1S23.6,13,23,13z M19,18c0,0.6-0.4,1-1,1H6
	c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1V18z"
    />
  ),
  reviews: () => (
    <path
      className="st0"
      d="M18.8,23.5C18.8,23.5,18.8,23.5,18.8,23.5H4.5c-1.7,0-3-1.3-3-3v-7c0-1.7,1.3-3,3-3h2.4l3.7-8.4
	c0.2-0.4,0.5-0.6,0.9-0.6c2.2,0,4,1.8,4,4v3h4.7c0.2,0,0.3,0,0.5,0c0.8,0.1,1.5,0.5,2,1.2c0.5,0.6,0.7,1.4,0.5,2.2l-1.4,9
	C21.5,22.4,20.3,23.5,18.8,23.5z M8.5,21.5h10.3c0.5,0,0.9-0.4,1-0.8l1.4-9c0-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.4-0.4-0.7-0.4
	c-0.1,0-0.1,0-0.2,0h-5.7c-0.6,0-1-0.4-1-1v-4c0-0.9-0.6-1.6-1.4-1.9l-3.6,8.1V21.5z M4.5,12.5c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1
	h2v-9H4.5z"
    />
  ),
  related: () => (
    <path
      className="st0"
      d="M18,23H6c-1.7,0-3-1.3-3-3V4c0-1.7,1.3-3,3-3h12c1.7,0,3,1.3,3,3v16C21,21.7,19.7,23,18,23z M6,3
	C5.4,3,5,3.4,5,4v16c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V4c0-0.6-0.4-1-1-1H6z M12,19c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5
	S14.8,19,12,19z M12,11c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.7,11,12,11z M13,6c0-0.6-0.4-1-1-1h0c-0.6,0-1,0.4-1,1s0.5,1,1,1
	S13,6.6,13,6z"
    />
  ),
  topArrow: () => (
    <path
      className="a"
      d="M4,5a.908.908,0,0,1-.7-.3l-3-3A.967.967,0,0,1,.3.3.967.967,0,0,1,1.7.3L4,2.6,6.3.3A.967.967,0,0,1,7.7.3a.967.967,0,0,1,0,1.4l-3,3A.908.908,0,0,1,4,5Z"
      transform="translate(8 5) rotate(180)"
    />
  ),
  bottomArrow: () => (
    <path
      className="a"
      d="M4,5a.908.908,0,0,1-.7-.3l-3-3A.967.967,0,0,1,.3.3.967.967,0,0,1,1.7.3L4,2.6,6.3.3A.967.967,0,0,1,7.7.3a.967.967,0,0,1,0,1.4l-3,3A.908.908,0,0,1,4,5Z"
    />
  ),
  photogalleryNext: () => (
    <path
      className="st0"
      d="M10.7,27.7c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l10-10L10,6c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L22,15.3
	c0.2,0.2,0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7L11.4,27.4C11.2,27.6,10.9,27.7,10.7,27.7z"
    />
  ),
  photogalleryBack: () => (
    <path
      className="st0"
      d="M21.3,27.7c-0.3,0-0.5-0.1-0.7-0.3L10,16.7c-0.2-0.2-0.3-0.4-0.3-0.7s0.1-0.5,0.3-0.7L20.6,4.6
	c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-10,10l10,10c0.4,0.4,0.4,1,0,1.4C21.8,27.6,21.6,27.7,21.3,27.7z"
    />
  ),
  fullscreen: () => (
    <path
      id="Path_90"
      className="st0"
      d="M7,14H5v5h5v-2H7V14z M5,10h2V7h3V5H5V10z M17,17h-3v2h5v-5h-2V17z M14,5v2h3v3h2V5H14z"
    />
  ),
  dog: () => (
    <path
      className="st0"
      d="M23.8,10.8l-5.6-6.7C18.2,4,18.1,3.9,18,3.8c0,0,0-0.1-0.1-0.1C17.5,3.3,16.8,3,16.1,3H7.9
	C7.2,3,6.5,3.3,6.1,3.7c0,0,0,0-0.1,0.1C5.9,3.9,5.8,4,5.8,4.1l-5.6,6.7C0.1,10.9,0,11.1,0,11.2c0,1.8,1.5,3.3,3.3,3.3
	c0.7,0,1.4-0.2,1.9-0.6v2.6c0,1.9,1.4,3.5,3.3,3.7c0.8,1.9,3,2.8,4.9,2c0.9-0.4,1.6-1.1,2-2c1.9-0.2,3.3-1.8,3.3-3.7V14
	c1.5,1.1,3.6,0.7,4.7-0.8c0.4-0.6,0.6-1.2,0.6-1.9C24,11.1,23.9,10.9,23.8,10.8L23.8,10.8z M3.3,13.2c-1,0-1.8-0.7-1.9-1.7l3.9-4.6
	v4.4C5.3,12.3,4.4,13.2,3.3,13.2z M12,21.1c-0.8,0-1.5-0.4-1.9-1c0.8-0.2,1.4-0.7,1.9-1.4c0.5,0.7,1.1,1.1,1.9,1.4
	C13.5,20.7,12.8,21.1,12,21.1z M12.1,15.7c0,0-0.1,0.1-0.1,0.1c0,0-0.1-0.1-0.1-0.1l-0.8-1.3c0,0,0-0.1-0.1-0.1c0,0,0.1,0,0.2,0h1.5
	c0.1,0,0.1,0,0.2,0c0,0,0,0.1-0.1,0.1L12.1,15.7z M17.3,16.5c0,1.3-1,2.3-2.3,2.3c-1.1,0-2-0.8-2.3-1.8c0.2-0.2,0.4-0.4,0.6-0.6
	l0.8-1.3c0.5-0.6,0.3-1.5-0.3-2c-0.3-0.2-0.6-0.3-1-0.3h-1.5c-0.8-0.1-1.5,0.5-1.6,1.3c0,0.4,0.1,0.7,0.3,1l0.8,1.3
	c0.1,0.2,0.3,0.5,0.6,0.6c-0.3,1.2-1.5,2-2.7,1.8c-1.1-0.2-1.8-1.2-1.8-2.3V5.6c0-0.2,0.1-0.5,0.2-0.7L7,4.7
	c0.2-0.2,0.5-0.3,0.8-0.3h8.3c0.3,0,0.6,0.1,0.8,0.3l0.2,0.2c0.1,0.2,0.2,0.4,0.2,0.7l0,0L17.3,16.5z M20.7,13.2
	c-1.1,0-1.9-0.9-1.9-1.9V6.9l3.9,4.6C22.5,12.4,21.6,13.2,20.7,13.2L20.7,13.2z M9,9C8.6,9,8.3,9.3,8.3,9.7c0,0.4,0.3,0.7,0.7,0.7
	c0.4,0,0.7-0.3,0.7-0.7c0-0.2-0.1-0.4-0.2-0.5C9.4,9.1,9.2,9,9,9z M15,9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7
	c0.4,0,0.7-0.3,0.7-0.7c0-0.2-0.1-0.4-0.2-0.5C15.4,9.1,15.2,9,15,9z"
    />
  ),
  google: () => (
    <path d="M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032 s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2 C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z" />
  ),
  info: () => (
    <path
      id="Path_422"
      className="st0"
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2
	V9z"
    />
  ),
  onStock: () => (
    <path
      className="st0"
      d="M21.7,6.7c0-0.1,0-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.3-0.5-0.6-0.9-0.8l-7-4c-0.9-0.5-2.1-0.5-3,0
	L7.3,3.2c-0.2,0-0.3,0.1-0.5,0.3L3.5,5.4C3.2,5.6,2.9,5.9,2.6,6.2C2.5,6.3,2.5,6.4,2.4,6.5c0,0.1,0,0.1-0.1,0.2C2.1,7.1,2,7.5,2,8v8
	c0,1.1,0.6,2.1,1.5,2.6l7,4c0.3,0.2,0.7,0.3,1,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.3-0.1,0.5-0.1c0.3-0.1,0.7-0.2,1-0.3l7-4
	c0.9-0.5,1.5-1.5,1.5-2.6v0V8C22,7.5,21.9,7.1,21.7,6.7z M11.5,3.1C11.7,3,11.8,3,12,3c0.2,0,0.3,0,0.5,0.1L19,6.8l-2.5,1.4l-6.9-4
	L11.5,3.1z M12,10.9l-7-4l2.5-1.4l7,4L12,10.9z M4.5,16.9C4.2,16.7,4,16.4,4,16V8.5l7,4v8L4.5,16.9z M19.5,16.9L13,20.6v-8l7-4V16
	C20,16.4,19.8,16.7,19.5,16.9z"
    />
  ),
  price: () => (
    <path
      className="st0"
      d="M19.1,17.9c-0.3,0-0.6,0.2-0.9,0.3c-0.9,0.4-1.8,0.7-2.8,0.7C13,19,10.9,17.5,10,15.3h6.1c0.4,0,1.3,0,1.3-1
	c0-0.9-0.6-0.9-1.3-0.9H9.5c-0.1-0.5-0.1-1.1-0.1-1.6c0-0.4,0-0.7,0.1-1.1h7.8c0.4,0,1.3,0,1.3-1c0-0.9-0.6-0.9-1.3-0.9H9.8
	c0.7-2.4,3-3.9,5.5-3.8c1,0,2,0.2,2.8,0.7C18.4,5.9,18.7,6,19,6.1c0.6,0,1-0.8,1-1.2c0-0.4-0.3-0.7-1-1C17.9,3.3,16.5,3,15.2,3
	c-3.7-0.2-7.1,2.3-8,5.9h-2c-0.4,0-1.3,0-1.3,1c0,0.9,0.6,0.9,1.3,0.9h1.6c0,0.4-0.1,0.8-0.1,1.2c0,0.5,0,1,0.1,1.5H5.3
	c-0.4,0-1.3,0-1.3,1c0,0.9,0.6,0.9,1.3,0.9h2c1,3.5,4.3,5.8,7.9,5.7c1.3,0,2.6-0.3,3.7-0.9c0.6-0.3,1-0.6,1-1.2
	C20,18.5,19.6,18,19.1,17.9C19.1,17.9,19.1,17.9,19.1,17.9z"
    />
  ),
  priceDown: () => (
    <path
      className="st0"
      d="M18.5,21L14,16h3v-6h3v6h3L18.5,21z M12.5,18.9c-0.1,0-0.1,0-0.2,0C10,19,7.9,17.5,7,15.3h3.5v-1.9h-4
	c-0.1-0.5-0.1-1.1-0.1-1.6c0-0.4,0-0.7,0.1-1.1h7.1V8.9H6.8c0.7-2.4,3-3.9,5.5-3.8c1,0,2,0.2,2.8,0.7c0.1,0,0.2,0.1,0.2,0.1
	C15.6,6,15.8,6.1,16,6.1c0.6,0,1-0.8,1-1.2c0-0.4-0.3-0.7-1-1C14.8,3.3,13.5,3,12.2,3c-1.8,0-3.6,0.5-5.1,1.5
	C5.7,5.6,4.7,7.1,4.2,8.9h-2c-0.4,0-1.3,0-1.3,1c0,0.9,0.6,0.9,1.3,0.9h1.6c0,0.4-0.1,0.8-0.1,1.2c0,0.5,0,1,0.1,1.5H2.3
	c-0.4,0-1.3,0-1.3,1c0,0.8,0.6,0.9,1.3,0.9h2.1c1,3.5,4.3,5.8,7.9,5.7c0.7,0,1.4-0.1,2-0.2L12.5,18.9z"
    />
  ),
  edit: () => (
    <path
      className="st0"
      d="M18,23.1H4c-1.7,0-3-1.3-3-3v-14c0-1.7,1.3-3,3-3h7c0.6,0,1,0.4,1,1s-0.4,1-1,1H4c-0.6,0-1,0.4-1,1v14
	c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1v-7c0-0.6,0.4-1,1-1s1,0.4,1,1v7C21,21.8,19.7,23.1,18,23.1z M8.2,17.1l4-1
	c0.2,0,0.3-0.1,0.5-0.3l9.5-9.5c1.2-1.2,1.2-3.2,0-4.4c-1.2-1.2-3.2-1.2-4.4,0l-9.5,9.5c-0.1,0.1-0.2,0.3-0.3,0.5l-1,4
	c-0.1,0.3,0,0.7,0.3,0.9C7.5,17,7.7,17.1,8,17.1C8.1,17.1,8.2,17.1,8.2,17.1z M19.2,3.3L19.2,3.3c0.4-0.4,1.2-0.4,1.6,0
	c0.4,0.4,0.4,1.1,0,1.6l-9.3,9.3l-2.1,0.5l0.5-2.1L19.2,3.3z M18.5,2.6L18.5,2.6L18.5,2.6z"
    />
  ),
  creditCard: () => (
    <path
      d="M73.3,22.7H22.7c-3.5,0-6.3,2.8-6.3,6.3l0,38c0,3.5,2.8,6.3,6.3,6.3h50.7
		c3.5,0,6.3-2.8,6.3-6.3V29C79.7,25.5,76.8,22.7,73.3,22.7z M73.3,67H22.7V48h50.7V67z M73.3,35.3H22.7V29h50.7V35.3z"
    />
  ),
  minus: () => <path d="M8,0v2H0V0H8z" />,
  plus: () => <path d="M3,8V5H0V3h3V0h2v3h3v2H5v3H3z" />,
  percentage: () => (
    <path
      d="M5,20c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l14-14c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-14,14C5.5,19.9,5.3,20,5,20z
	 M10,6.5C10,4.6,8.4,3,6.5,3S3,4.6,3,6.5S4.6,10,6.5,10S10,8.4,10,6.5z M8,6.5C8,7.3,7.3,8,6.5,8S5,7.3,5,6.5S5.7,5,6.5,5
	S8,5.7,8,6.5z M21,17.5c0-1.9-1.6-3.5-3.5-3.5S14,15.6,14,17.5s1.6,3.5,3.5,3.5S21,19.4,21,17.5z M19,17.5c0,0.8-0.7,1.5-1.5,1.5
	S16,18.3,16,17.5s0.7-1.5,1.5-1.5S19,16.7,19,17.5z"
    />
  ),
  finishedOrder: () => (
    <path
      d="M24,44C13,44,4,35,4,24C4,13,13,4,24,4c11,0,20,9,20,20C44,35,35,44,24,44z M24,6C14.1,6,6,14.1,6,24
	c0,9.9,8.1,18,18,18c9.9,0,18-8.1,18-18C42,14.1,33.9,6,24,6z M22.2,29.6l10.6-10c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0
	l-9.9,9.3l-4.7-4.8c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l5.4,5.5c0.2,0.2,0.5,0.3,0.7,0.3C21.8,29.9,22,29.8,22.2,29.6z"
    />
  ),
  emptyCart: () => (
    <path
      d="M31,23.4L29.6,22L24,27.6L18.4,22L17,23.4l5.6,5.6L17,34.6l1.4,1.4l5.6-5.6l5.6,5.6l1.4-1.4L25.4,29L31,23.4z
  M40.2,12.8H33v-2C33,5.3,29,1,24,1s-9,4.3-9,9.7v2H7.9c-1.3,0-1.9,0.8-1.8,1.7l2.5,26.9c0,3.1,2.6,5.4,6.1,5.4h18.7
 c3.5,0,6.1-2.3,6.1-5.3l2.6-27C42,13.5,41.2,12.8,40.2,12.8z M17,10.7C17,6.4,20.1,3,24,3c3.9,0,7,3.4,7,7.7v2H17V10.7z M37.5,41.4
 c0,1.9-1.8,3.4-4.1,3.4H14.6c-2.3,0-4.1-1.5-4.1-3.5L8,14.8l31.9,0L37.5,41.4z"
    />
  ),
  cross: () => (
    <path
      d="M12.7,11.3c0.4,0.4,0.4,1,0,1.4C12.5,12.9,12.3,13,12,13s-0.5-0.1-0.7-0.3L8,9.4l-3.3,3.3C4.5,12.9,4.3,13,4,13
	s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L6.6,8L3.3,4.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L8,6.6l3.3-3.3c0.4-0.4,1-0.4,1.4,0
	s0.4,1,0,1.4L9.4,8L12.7,11.3z"
    />
  ),
  closeThin: () => (
    <path
      d="M18.7,17.3c0.4,0.4,0.4,1,0,1.4C18.5,18.9,18.3,19,18,19s-0.5-0.1-0.7-0.3L12,13.4l-5.3,5.3
	C6.5,18.9,6.3,19,6,19s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l5.3-5.3L5.3,6.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5.3,5.3l5.3-5.3
	c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L13.4,12L18.7,17.3z"
    />
  ),
  backThin: () => (
    <polygon points="15.3,20.7 6.6,12 15.3,3.3 16.7,4.7 9.4,12 16.7,19.3 " />
  ),
  recycled: () => (
    <path
      d="M15.92,8.1l3.93,2.04-2.36,1.23-3.93-2.04,2.36-1.23Zm-5.54,0l2.36,1.23-3.93,2.04-2.36-1.23,3.93-2.04Zm-1.56,3.68l3.93,2.04-2.36,1.23-3.93-2.04,2.36-1.23Zm.19,2.98l1.29,.67c.06,.03,.12,.03,.17,0l2.5-1.3v4.28l-3.96-2.06v-1.6Zm8.29,1.6l-3.96,2.06v-4.28l2.5,1.3s.06,.02,.09,.02,.06,0,.09-.02l1.29-.67v1.6Zm-1.37-1.31l-2.36-1.23,3.93-2.04,2.36,1.23-3.93,2.04Z"
      fill="#dd9f45"
    />
  ),
  delivery: () => (
    <g>
      <rect x="15.26" y="8.46" width=".92" height=".82" />
      <polygon points="18.06 9.82 16.71 9.82 16.71 12.03 19.67 12.03 18.06 9.82" />
      <path d="M8.28,17.16c.61,0,1.11-.46,1.2-1.05h-2.4c.08,.59,.58,1.05,1.2,1.05Z" />
      <path d="M16.44,12.57c-.07,0-.14-.03-.19-.08-.05-.05-.08-.12-.08-.19v-2.47h-.91v5.75h4.66v-3h-3.48Z" />
      <path d="M17.51,17.16c.61,0,1.12-.46,1.2-1.05h-2.4c.08,.59,.58,1.05,1.2,1.05Z" />
      <path d="M6.24,15.57H14.72v-7.11H6.24v7.11Z" />
    </g>
  ),
  new_old: () => (
    <path d="M12.67,18.46c-.22,0-.41-.09-.56-.27-.16-.18-.22-.39-.2-.63l.25-3.38c.02-.07,.01-.13-.04-.16-.05-.04-.1-.03-.15,.02l-2.83,1.96c-.19,.14-.41,.19-.65,.14-.24-.05-.42-.18-.54-.4-.14-.24-.18-.47-.09-.69,.08-.22,.25-.39,.49-.51l3.12-1.45c.07-.02,.11-.06,.11-.11s-.04-.08-.11-.11l-3.12-1.49c-.24-.12-.4-.3-.47-.53-.07-.23-.05-.45,.07-.67,.15-.24,.33-.37,.56-.4,.23-.02,.44,.02,.63,.14l2.83,1.96s.1,.06,.15,.04c.05-.02,.06-.07,.04-.15l-.25-3.37c-.02-.24,.05-.45,.22-.63,.17-.18,.38-.27,.62-.27s.44,.09,.58,.27,.2,.39,.18,.63l-.25,3.37c-.02,.07-.01,.12,.04,.15,.05,.02,.11,.01,.18-.04l2.79-1.92c.22-.14,.45-.19,.69-.14s.42,.18,.55,.4c.14,.22,.17,.44,.07,.65-.1,.22-.27,.39-.51,.51l-3.09,1.49c-.07,.02-.11,.06-.11,.11s.04,.08,.11,.11l3.09,1.45c.27,.12,.44,.29,.51,.51,.07,.22,.05,.45-.07,.69-.12,.22-.3,.35-.55,.4-.24,.05-.47,0-.69-.14l-2.79-1.96c-.07-.05-.13-.05-.18-.02-.05,.04-.06,.09-.04,.16l.25,3.38c.02,.24-.04,.45-.2,.63-.16,.18-.37,.27-.63,.27Z" />
  ),
  new : () => (
    <g id="surface1" transform="translate(3,3) scale(0.8,0.8)">
      <path style={{fill:"#ff1e45"}} d="M 2.234375 12.949219 L 2.234375 18.097656 L 4.109375 18.097656 L 4.109375 17.769531 C 4.109375 17.589844 4.070312 15.96875 4.023438 14.164062 C 3.984375 12.359375 3.953125 10.800781 3.960938 10.695312 C 3.972656 10.5625 4.285156 11.554688 5.097656 14.304688 L 6.214844 18.097656 L 8.527344 18.097656 L 8.527344 7.800781 L 7.597656 7.800781 C 7.082031 7.800781 6.652344 7.816406 6.640625 7.835938 C 6.625 7.863281 6.660156 9.179688 6.714844 10.765625 C 6.769531 12.351562 6.808594 13.773438 6.800781 13.929688 C 6.785156 14.171875 6.675781 13.800781 5.960938 11.121094 C 5.507812 9.421875 5.117188 7.980469 5.089844 7.914062 L 5.042969 7.800781 L 2.234375 7.800781 Z M 2.234375 12.949219 "/>
      <path style={{fill:"#ff1e45"}} d="M 9.410156 12.949219 L 9.410156 18.097656 L 13.988281 18.097656 L 13.988281 16.066406 L 11.492188 16.066406 L 11.492188 13.675781 L 13.363281 13.675781 L 13.363281 12.167969 L 11.492188 12.167969 L 11.492188 9.828125 L 13.882812 9.828125 L 13.882812 7.800781 L 9.410156 7.800781 Z M 9.410156 12.949219 "/>
      <path style={{fill:"#ff1e45"}} d="M 14.378906 7.964844 C 14.496094 8.640625 16.015625 17.976562 16.015625 18.027344 C 16.015625 18.082031 16.269531 18.097656 17.15625 18.097656 C 18.199219 18.097656 18.296875 18.085938 18.320312 18.003906 C 18.335938 17.957031 18.527344 16.503906 18.75 14.777344 C 18.976562 13.058594 19.171875 11.648438 19.1875 11.648438 C 19.203125 11.648438 19.363281 12.90625 19.546875 14.441406 C 19.730469 15.980469 19.902344 17.429688 19.925781 17.664062 L 19.984375 18.097656 L 22.355469 18.097656 L 22.386719 17.925781 C 22.5625 16.929688 24.023438 7.988281 24.023438 7.902344 C 24.023438 7.804688 23.992188 7.800781 23.015625 7.800781 L 22.007812 7.800781 L 21.976562 8.042969 C 21.960938 8.183594 21.789062 9.746094 21.605469 11.519531 C 21.417969 13.292969 21.257812 14.761719 21.246094 14.792969 C 21.207031 14.914062 21.152344 14.539062 20.773438 11.386719 C 20.554688 9.574219 20.367188 8.023438 20.351562 7.941406 L 20.320312 7.800781 L 19.3125 7.800781 C 18.460938 7.800781 18.304688 7.808594 18.304688 7.878906 C 18.304688 8.023438 17.472656 14.789062 17.453125 14.808594 C 17.421875 14.839844 17.398438 14.691406 17.03125 11.257812 C 16.84375 9.542969 16.675781 8.058594 16.660156 7.964844 L 16.636719 7.800781 L 14.347656 7.800781 Z M 14.378906 7.964844 "/>
    </g>
  ),
  saleout: () => (
    <g>
      <path d="M8.54,9.8c.02-.35,.1-.66,.23-.92s.3-.47,.5-.65,.43-.3,.69-.38,.52-.12,.78-.12,.53,.04,.79,.13,.49,.22,.7,.39c.21,.17,.37,.39,.5,.64,.12,.25,.19,.54,.19,.87s-.06,.62-.19,.89c-.13,.27-.3,.5-.51,.7-.21,.2-.45,.35-.72,.45-.27,.11-.55,.16-.83,.16-.25,0-.5-.05-.74-.14-.24-.1-.46-.23-.66-.42-.2-.18-.36-.41-.49-.68-.13-.27-.2-.57-.22-.92Zm7.24-2.1c.14-.13,.33-.2,.55-.2,.18,0,.34,.06,.47,.17,.13,.12,.19,.26,.19,.43,0,.05,0,.09-.01,.14s-.02,.09-.04,.14l-3.09,4.44-3.3,4.73c-.09,.11-.19,.19-.3,.23-.12,.04-.22,.06-.32,.06-.18,0-.34-.05-.47-.16-.13-.11-.19-.25-.19-.43,0-.07,0-.14,.03-.21,.02-.07,.05-.14,.1-.22,.57-.8,1.12-1.58,1.64-2.33s1.03-1.49,1.55-2.23c.51-.73,1.03-1.47,1.55-2.21,.53-.75,1.07-1.52,1.64-2.33h.01Zm-5.09,1.25c-.11,0-.21,.03-.29,.08-.08,.05-.15,.12-.21,.2-.06,.08-.1,.17-.14,.27s-.06,.2-.08,.3c.03,.3,.12,.51,.27,.65,.15,.13,.32,.2,.52,.2s.35-.07,.51-.22c.16-.14,.24-.36,.24-.65,0-.23-.08-.43-.25-.59-.17-.16-.36-.24-.57-.24Zm2.79,6.65c.02-.34,.09-.64,.22-.9,.13-.25,.29-.46,.5-.63,.2-.17,.43-.29,.68-.37,.25-.08,.5-.12,.76-.12s.52,.04,.77,.13c.25,.09,.48,.21,.69,.38,.21,.17,.37,.37,.5,.62,.12,.24,.19,.53,.19,.85s-.06,.64-.18,.91c-.12,.27-.28,.49-.48,.68s-.43,.32-.7,.42c-.26,.1-.53,.14-.81,.14-.24,0-.48-.04-.72-.12s-.46-.21-.66-.38-.37-.39-.5-.65c-.13-.26-.21-.58-.24-.94Zm2.15-.76c-.25,0-.42,.08-.52,.24s-.17,.34-.19,.52c.03,.28,.12,.49,.26,.63s.31,.21,.5,.21c.16,0,.32-.07,.47-.21s.23-.35,.23-.63c0-.24-.08-.43-.23-.56-.15-.13-.33-.2-.52-.2Z" />
      <circle cx="10.59" cy="9.53" r="1.63" />
      <ellipse cx="16.01" cy="15.49" rx="1.63" ry="1.08" />
    </g>
  ),
  gift: () => (
    <g>
      <path
      id="Path_363"
      data-name="Path 363"
      transform='translate(4.6,4.6) scale(0.7,0.7)'
      d="M24,6H20.4A3.606,3.606,0,0,0,21,4a4.012,4.012,0,0,0-4-4,6.068,6.068,0,0,0-5,2.7A6.068,6.068,0,0,0,7,0,4.012,4.012,0,0,0,3,4a3.606,3.606,0,0,0,.6,2H0v8H2V24H22V14h2ZM17,2a2,2,0,0,1,0,4H13A4.012,4.012,0,0,1,17,2ZM5,4A2.006,2.006,0,0,1,7,2a4.012,4.012,0,0,1,4,4H7A2.006,2.006,0,0,1,5,4ZM2,8H9v4H2ZM4,22V14H9v8Zm7,0V8h2V22Zm9,0H15V14h5Zm2-10H15V8h7Z"
    />
    </g> 

  ),
  logout: () => (
    <g id="surface1">
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(0%,0%,0%)',
          fillOpacity: 1,
        }}
        d="M 19.585938 13 L 8.496094 13 C 8.230469 13 7.976562 12.894531 7.789062 12.707031 C 7.601562 12.519531 7.5 12.265625 7.5 12 C 7.5 11.449219 7.945312 11.003906 8.496094 11 L 19.585938 11 L 15.792969 7.207031 C 15.414062 6.816406 15.417969 6.191406 15.804688 5.804688 C 16.191406 5.417969 16.816406 5.414062 17.207031 5.792969 L 22.707031 11.292969 C 23.097656 11.683594 23.097656 12.316406 22.707031 12.707031 L 17.207031 18.207031 C 16.816406 18.585938 16.191406 18.582031 15.804688 18.195312 C 15.417969 17.808594 15.414062 17.183594 15.792969 16.792969 Z M 13 1 C 13.550781 1 14 1.449219 14 2 C 14 2.550781 13.550781 3 13 3 L 3.503906 3 C 3.222656 3 3 3.222656 3 3.503906 L 3 20.496094 C 3 20.773438 3.226562 21 3.503906 21 L 13 21 C 13.550781 21 14 21.449219 14 22 C 14 22.550781 13.550781 23 13 23 L 3.503906 23 C 2.121094 23 1 21.878906 1 20.496094 L 1 3.503906 C 1 2.839844 1.261719 2.203125 1.734375 1.734375 C 2.203125 1.261719 2.839844 1 3.503906 1 Z M 13 1 "
      />
    </g>
  ),
  eye: () => (
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: 'rgb(0%,0%,0%)',
        fillOpacity: 1,
      }}
      d="M 23.855469 11.390625 C 21.59375 6.984375 17.121094 4 12 4 C 6.878906 4 2.402344 6.984375 0.144531 11.390625 C -0.046875 11.773438 -0.046875 12.226562 0.144531 12.609375 C 2.40625 17.015625 6.878906 20 12 20 C 17.121094 20 21.597656 17.015625 23.855469 12.609375 C 24.046875 12.226562 24.046875 11.773438 23.855469 11.390625 Z M 12 18 C 8.6875 18 6 15.3125 6 12 C 6 8.6875 8.6875 6 12 6 C 15.3125 6 18 8.6875 18 12 C 18 15.3125 15.3125 18 12 18 Z M 12 8 C 11.644531 8.003906 11.289062 8.058594 10.945312 8.15625 C 11.53125 8.953125 11.445312 10.050781 10.75 10.75 C 10.050781 11.445312 8.953125 11.53125 8.15625 10.945312 C 7.710938 12.597656 8.363281 14.351562 9.785156 15.304688 C 11.207031 16.257812 13.078125 16.199219 14.4375 15.15625 C 15.796875 14.117188 16.339844 12.324219 15.789062 10.703125 C 15.234375 9.085938 13.710938 7.996094 12 8 Z M 12 8 "
    />
  ),
  eyeSlash: () => (
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: 'rgb(0%,0%,0%)',
        fillOpacity: 1,
      }}
      d="M 12 17.398438 C 9.15625 17.398438 6.851562 15.199219 6.640625 12.410156 L 2.707031 9.367188 C 2.191406 10.015625 1.714844 10.703125 1.332031 11.453125 C 1.15625 11.796875 1.15625 12.203125 1.332031 12.546875 C 3.363281 16.515625 7.390625 19.199219 12 19.199219 C 13.007812 19.199219 13.984375 19.050781 14.921875 18.808594 L 12.976562 17.300781 C 12.652344 17.363281 12.328125 17.398438 12 17.398438 Z M 23.769531 19.578125 L 19.621094 16.375 C 20.882812 15.3125 21.917969 14.011719 22.667969 12.546875 C 22.84375 12.203125 22.84375 11.796875 22.667969 11.453125 C 20.636719 7.484375 16.609375 4.800781 12 4.800781 C 10.070312 4.800781 8.171875 5.289062 6.476562 6.214844 L 1.703125 2.527344 C 1.441406 2.324219 1.066406 2.371094 0.863281 2.632812 L 0.125 3.578125 C -0.078125 3.839844 -0.03125 4.21875 0.230469 4.421875 L 22.296875 21.472656 C 22.558594 21.675781 22.933594 21.628906 23.136719 21.367188 L 23.875 20.421875 C 24.078125 20.160156 24.03125 19.78125 23.769531 19.578125 Z M 16.878906 14.253906 L 15.40625 13.113281 C 15.527344 12.753906 15.59375 12.378906 15.601562 12 C 15.613281 10.875 15.09375 9.804688 14.195312 9.125 C 13.300781 8.441406 12.132812 8.226562 11.050781 8.542969 C 11.277344 8.847656 11.398438 9.21875 11.398438 9.601562 C 11.394531 9.726562 11.375 9.851562 11.34375 9.976562 L 8.582031 7.839844 C 9.539062 7.039062 10.75 6.601562 12 6.601562 C 13.433594 6.597656 14.804688 7.167969 15.820312 8.179688 C 16.832031 9.195312 17.402344 10.566406 17.398438 12 C 17.398438 12.8125 17.203125 13.566406 16.878906 14.253906 Z M 16.878906 14.253906 "
    />
  ),
  tiktok: () => (   
    <g id="surface1">
        <path
        fill="#fff" 
        d="M 19.589844 6.6875 C 17.539062 6.246094 16.011719 4.527344 15.820312 2.441406 L 15.820312 2 L 12.375 2 L 12.375 15.671875 C 12.371094 16.914062 11.574219 18.011719 10.398438 18.40625 C 9.222656 18.800781 7.925781 18.402344 7.171875 17.414062 C 6.410156 16.410156 6.386719 15.027344 7.113281 13.996094 C 7.839844 12.964844 9.152344 12.523438 10.355469 12.90625 L 10.355469 9.40625 C 7.675781 9.035156 5.058594 10.410156 3.839844 12.824219 C 2.621094 15.238281 3.070312 18.160156 4.960938 20.097656 C 6.761719 21.9375 9.496094 22.503906 11.878906 21.535156 C 14.261719 20.5625 15.820312 18.246094 15.820312 15.671875 L 15.820312 8.6875 C 17.210938 9.683594 18.878906 10.214844 20.59375 10.214844 L 20.59375 6.789062 C 20.253906 6.789062 19.917969 6.753906 19.589844 6.6875 Z M 19.589844 6.6875 "/>
    </g> 
  ),
  deal: () => (
    <g id="surface1" transform="translate(3,3) scale(0.8,0.8)">
      <path d="M 21.816406 0.730469 C 21.414062 0.90625 21.351562 1.15625 21.53125 1.828125 C 21.648438 2.257812 21.667969 2.410156 21.667969 2.988281 C 21.671875 3.492188 21.648438 3.746094 21.582031 4.003906 C 21.339844 4.921875 20.8125 5.824219 20.03125 6.621094 C 19.632812 7.027344 18.699219 7.820312 18.613281 7.820312 C 18.59375 7.820312 18.417969 7.589844 18.226562 7.3125 C 18.019531 7.015625 17.785156 6.742188 17.660156 6.648438 C 17.261719 6.351562 17.242188 6.347656 14.933594 6.316406 C 12.59375 6.285156 12.5625 6.289062 11.976562 6.601562 C 11.816406 6.6875 10.894531 7.269531 9.925781 7.898438 C 8.957031 8.523438 7.199219 9.660156 6.023438 10.417969 C 0.824219 13.769531 0.652344 13.886719 0.511719 14.074219 C 0.441406 14.175781 0.355469 14.371094 0.328125 14.503906 C 0.226562 14.96875 0.0820312 14.738281 3.191406 19.160156 C 3.566406 19.691406 4.199219 20.59375 4.601562 21.167969 C 5 21.738281 5.398438 22.273438 5.480469 22.351562 C 5.691406 22.550781 5.953125 22.609375 6.289062 22.539062 C 6.5625 22.480469 6.886719 22.273438 12.550781 18.617188 C 13.398438 18.074219 14.976562 17.058594 16.054688 16.359375 C 17.140625 15.660156 18.097656 15.023438 18.175781 14.941406 C 18.511719 14.597656 18.664062 14.3125 18.980469 13.398438 C 19.152344 12.898438 19.445312 12.066406 19.632812 11.546875 C 19.921875 10.730469 19.96875 10.558594 19.96875 10.277344 C 19.96875 9.867188 19.914062 9.722656 19.617188 9.296875 L 19.378906 8.953125 L 19.492188 8.882812 C 19.78125 8.699219 20.671875 7.910156 21.070312 7.484375 C 22.757812 5.6875 23.390625 3.648438 22.890625 1.605469 C 22.753906 1.019531 22.660156 0.859375 22.402344 0.742188 C 22.148438 0.621094 22.066406 0.621094 21.816406 0.730469 Z M 16.871094 8.164062 C 17.160156 8.238281 17.519531 8.410156 17.519531 8.472656 C 17.519531 8.492188 17.355469 8.59375 17.160156 8.699219 C 16.746094 8.914062 16.628906 9.035156 16.585938 9.292969 C 16.539062 9.53125 16.691406 9.835938 16.90625 9.953125 C 17.1875 10.121094 17.457031 10.058594 18.253906 9.667969 C 18.273438 9.660156 18.289062 9.785156 18.289062 9.949219 C 18.289062 10.300781 18.160156 10.6875 17.953125 10.964844 C 17.546875 11.5 16.753906 11.8125 16.117188 11.6875 C 15.015625 11.46875 14.34375 10.484375 14.609375 9.484375 C 14.871094 8.515625 15.886719 7.921875 16.871094 8.164062 Z M 12.125 8.246094 C 12.246094 8.308594 12.371094 8.480469 14.761719 11.894531 L 16.414062 14.253906 L 16.414062 14.5 C 16.410156 14.757812 16.371094 14.847656 16.167969 15.078125 C 16.097656 15.160156 14.777344 16.039062 13.238281 17.039062 C 11.699219 18.03125 9.609375 19.390625 8.59375 20.050781 L 6.742188 21.246094 L 6.4375 21.253906 C 5.964844 21.253906 5.894531 21.191406 5.175781 20.152344 C 4.828125 19.65625 3.898438 18.335938 3.109375 17.214844 C 2.324219 16.09375 1.664062 15.117188 1.652344 15.042969 C 1.632812 14.96875 1.636719 14.808594 1.65625 14.6875 C 1.683594 14.496094 1.726562 14.433594 2.007812 14.175781 C 2.449219 13.773438 11.074219 8.242188 11.351562 8.1875 C 11.582031 8.140625 11.972656 8.167969 12.125 8.246094 Z M 12.125 8.246094 "/>
      <path d="M 11.207031 10.421875 C 10.996094 10.5625 10.824219 10.699219 10.828125 10.730469 C 10.832031 10.777344 13.472656 14.574219 13.578125 14.683594 C 13.601562 14.710938 15.128906 13.757812 15.253906 13.644531 C 15.289062 13.605469 14.785156 12.878906 14.726562 12.878906 C 14.699219 12.878906 14.503906 12.996094 14.300781 13.132812 C 14.09375 13.269531 13.914062 13.386719 13.90625 13.386719 C 13.902344 13.386719 13.386719 12.664062 12.769531 11.777344 C 12.148438 10.894531 11.628906 10.171875 11.617188 10.171875 C 11.601562 10.171875 11.417969 10.285156 11.207031 10.421875 Z M 11.207031 10.421875 "/>
      <path d="M 9.082031 11.804688 C 8.707031 12.042969 8.542969 12.171875 8.5625 12.21875 C 8.671875 12.5 10.476562 16.679688 10.492188 16.695312 C 10.523438 16.726562 11.328125 16.195312 11.328125 16.144531 C 11.328125 16.117188 11.257812 15.957031 11.164062 15.789062 C 10.90625 15.289062 10.894531 15.328125 11.3125 15.066406 L 11.679688 14.839844 L 11.996094 15.171875 C 12.167969 15.355469 12.328125 15.503906 12.351562 15.503906 C 12.371094 15.503906 12.601562 15.363281 12.867188 15.195312 L 13.347656 14.886719 L 12.972656 14.53125 C 11.957031 13.566406 9.675781 11.453125 9.652344 11.453125 C 9.632812 11.453125 9.378906 11.609375 9.082031 11.804688 Z M 10.488281 13.5625 C 10.851562 13.945312 11.140625 14.269531 11.132812 14.277344 C 11.121094 14.289062 10.992188 14.367188 10.847656 14.457031 L 10.585938 14.628906 L 10.136719 13.738281 C 9.886719 13.257812 9.667969 12.804688 9.644531 12.742188 L 9.59375 12.628906 L 9.710938 12.742188 C 9.773438 12.804688 10.125 13.175781 10.488281 13.5625 Z M 10.488281 13.5625 "/>
      <path d="M 6.585938 13.40625 C 6.105469 13.71875 5.699219 13.980469 5.683594 13.992188 C 5.664062 14.011719 8.289062 17.804688 8.472656 18.019531 C 8.476562 18.027344 8.894531 17.761719 9.402344 17.429688 C 10.054688 17 10.320312 16.808594 10.300781 16.757812 C 10.28125 16.707031 9.9375 16.21875 9.804688 16.058594 C 9.796875 16.042969 9.5625 16.1875 9.28125 16.371094 C 9.003906 16.554688 8.769531 16.699219 8.765625 16.6875 C 8.753906 16.679688 8.605469 16.46875 8.433594 16.21875 L 8.117188 15.757812 L 8.5 15.511719 L 8.886719 15.265625 L 8.804688 15.144531 C 8.554688 14.773438 8.480469 14.675781 8.460938 14.675781 C 8.453125 14.675781 8.285156 14.773438 8.089844 14.902344 C 7.890625 15.027344 7.722656 15.132812 7.707031 15.132812 C 7.679688 15.132812 7.042969 14.253906 7.066406 14.242188 C 7.070312 14.238281 7.28125 14.097656 7.527344 13.9375 C 7.769531 13.78125 7.980469 13.632812 7.996094 13.613281 C 8.015625 13.578125 7.503906 12.824219 7.472656 12.839844 C 7.46875 12.839844 7.070312 13.097656 6.585938 13.40625 Z M 6.585938 13.40625 "/>
      <path d="M 4.59375 14.816406 C 4.34375 14.871094 4.191406 14.953125 3.539062 15.375 C 3.132812 15.636719 2.976562 15.757812 2.996094 15.804688 C 3.007812 15.847656 3.636719 16.753906 4.390625 17.828125 L 5.765625 19.78125 L 6.339844 19.40625 C 6.65625 19.203125 7.003906 18.960938 7.109375 18.871094 C 7.757812 18.3125 7.65625 17.558594 6.757812 16.25 C 6.363281 15.675781 5.746094 15.058594 5.425781 14.917969 C 5.152344 14.796875 4.832031 14.757812 4.59375 14.816406 Z M 5.035156 15.847656 C 5.328125 15.988281 6.035156 16.886719 6.339844 17.503906 C 6.5625 17.941406 6.519531 18.175781 6.1875 18.371094 L 6.0625 18.445312 L 5.242188 17.277344 C 4.785156 16.632812 4.40625 16.078125 4.386719 16.039062 C 4.359375 15.957031 4.632812 15.777344 4.789062 15.777344 C 4.851562 15.777344 4.964844 15.808594 5.035156 15.847656 Z M 5.035156 15.847656 "/>
    </g>
  )

};

function SvgIcon({
  icon,
  className,
  viewBox = '0 0 24 24',
  fill,
  cursor,
  title = '',
  alt = '',
  marginLeft = 0,
  width = 24,
  height = 24,
  marginRight = 0,
  onClick = null,
  onMouseOver = null,
  onMouseLeave = null,
  padding = '',
}: Props) {
  const IconSrc = icons[icon];

  return (
    <IconWrapper
      cursor={cursor}
      fill={fill}
      className={className}
      viewBox={viewBox}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      marginLeft={marginLeft}
      marginRight={marginRight}
      width={width}
      height={height}
      padding={padding}
    >
      <title id="idTitle">{title}</title>
      <desc id="idDesc">{alt}</desc>
      <IconSrc />
    </IconWrapper>
  );
}

const IconStyles = css`
  vertical-align: middle;
`;

const IconWrapper = styled.svg<{
  fill?: string;
  cursor?: string;
  marginLeft: number;
  marginRight: number;
  width: number;
  height: number;
  padding?: string;
}>`
  ${IconStyles};
  fill: ${({ theme, fill }) => (fill ? fill : theme.colors.primary)};
  cursor: ${({ cursor }) => (cursor ? cursor : 'initial')};
  transition: fill 0.2s ease;
  margin-left: ${props => rem(props.marginLeft)};
  margin-right: ${props => rem(props.marginRight)};
  width: ${props => rem(props.width)};
  height: ${props => rem(props.height)};
  padding: ${({ padding }) => (padding ? padding : 'initial')};
`;

const IconPath = styled.path``;

export { SvgIcon as DsiSvgIcon };
